// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCog, iconCogTag } from '@ni/nimble-components/dist/esm/icons/cog';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCog };
export { iconCogTag };
export const NimbleIconCog = wrap(IconCog);